import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import { TagsInput } from "react-tag-input-component";
import { DeletePreBookingRoom, getBasicPropertydetails, GetPreBookingRoomdetail, PropeortyBookingConfirm, PropertyBusinessSourceList, PropertyGuaranteeCodes, PropertyMarketSegmentApi, PropertyMealplan, PropertyRateCode, roomlistdetail, SavePreBookingRoomAdd } from '../../Services/Service';

const HotelBooking = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [masterDetails, setMasterDetails] = useState({});
  const [roomDetails, setRoomDetails] = useState([]);
  const [tax, setTax] = useState(0);
  const [, setTotalAmount] = useState(0);
  const [, setTotalAfterTax] = useState(0);
  const [, setTaxAmount] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [, setMealPlans] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [, setSelectedRatePlan] = useState(null);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [extraBed, setExtraBed] = useState(0);
  const [marketSegments, setMarketSegments] = useState([]);
  const [businessSources, setBusinessSources] = useState([]);
  // const [editingRoomId, setEditingRoomId] = useState(null); // track which row is being edited
  const [tempAmount, setTempAmount] = useState({});
  const [roomAmount, setRoomAmount] = useState(0);
  const [Pms, setPMS] = useState();
  const [guaranteeCodes, setGuaranteeCodes] = useState([]);
  const [ratecode, setRatecode] = useState([]);
  const [mealplan, setMealplan] = useState([]);

  const [selectedRateCode, setSelectedRateCode] = useState("");

  const [editingRowKey, setEditingRowKey] = useState(null); // unique per rendered row

  const [savedAmounts, setSavedAmounts] = useState({});

  const [rowTax, setRowTax] = useState({});
  const [rowTaxAmount, setRowTaxAmount] = useState({});
  const [rowTotal, setRowTotal] = useState({});
  const [, setSavedRowTaxAmount] = useState({});

  const [isCopied, setIsCopied] = useState(false);
  const [, setCopiedAmount] = useState(null);


  useEffect(() => {
    const fetchBookingData = async () => {
      try {
        const result = await GetPreBookingRoomdetail();
        // console.log("Fetched booking data:", result);

        if (result?.MasterDetails?.length) {
          const master = result.MasterDetails[0];
          setMasterDetails(master);

          // Try to parse CompDetails (it may be a JSON string like "[{...}]")
          try {
            const compRaw = master.CompDetails;
            if (compRaw) {
              let compParsed = compRaw;

              // If it's a string, try to JSON.parse
              if (typeof compRaw === "string") {
                // sometimes it's double-encoded or a JSON array string
                compParsed = JSON.parse(compRaw);
              }

              // compParsed expected to be an array or object; normalize to first object
              const compObj = Array.isArray(compParsed) ? compParsed[0] : compParsed;

              if (compObj && typeof compObj === "object") {
                // Map API fields -> our form fields
                const registrationNumber = compObj.Gst ?? "";
                const registrationCompanyName = compObj.TA_Name ?? "";
                const registrationCompanyAddress = compObj.Address ?? "";

                // Update formData with parsed values
                setFormData((prev) => ({
                  ...prev,
                  RegistrationNumber: registrationNumber,
                  RegistrationCompanyName: registrationCompanyName,
                  RegistrationCompanyAddress: registrationCompanyAddress,
                }));
              }
            }
          } catch (parseErr) {
            console.warn("Failed to parse CompDetails:", parseErr);
          }
        }

        if (result?.RoomDetails?.length) {
          setRoomDetails(result.RoomDetails);

          const amount = result.RoomDetails.reduce((acc, room) => {
            const roomRate = room.RoomRate || room.PerRoomRate || 0;
            const totalRoomCount = room.TotalRoom || 1;

            // If API already gives ExtraBedAmount, use it
            const extraBedTotal =
              room.ExtraBedAmount !== undefined
                ? room.ExtraBedAmount
                : (room.ExtraBed || 0) * (room.ExtraBedCharges || 0);

            return acc + totalRoomCount * roomRate + extraBedTotal;
          }, 0);

          // console.log("ammount", amount);
          setTotalAmount(amount);

          // use TaxDetails from API if present, otherwise fallback to amount-based logic
          let taxPercent = 0;
          if (result?.TaxDetails && result.TaxDetails.length && result.TaxDetails[0].Tax != null) {
            taxPercent = Number(result.TaxDetails[0].Tax) || 0;
          } else {
            taxPercent = amount < 7500 ? 5 : 18;
          }
          setTax(taxPercent);

          const calculatedTaxAmount = (amount * taxPercent) / 100;
          setTaxAmount(calculatedTaxAmount);

          const afterTax = amount + calculatedTaxAmount;
          setTotalAfterTax(afterTax);
        }
      } catch (err) {
        console.error("Failed to fetch booking data", err);
      }
    };

    fetchBookingData();
  }, []);



  useEffect(() => {
    if (!roomDetails || roomDetails.length === 0) return;

    const newRowTax = {};
    const newRowTaxAmount = {};
    const newRowTotal = {};

    roomDetails.forEach((room, roomIdx) => {
      const instances = room.TotalRoom || 1;

      for (let i = 0; i < instances; i++) {
        const rowKey = `${roomIdx}-${i}`;

        const defaultAmount =
          room.Amount ??
          (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0));

        const taxPercent = defaultAmount < 7500 ? 5 : 18;

        const taxAmt = (defaultAmount * taxPercent) / 100;
        const total = defaultAmount + taxAmt;

        newRowTax[rowKey] = taxPercent;
        newRowTaxAmount[rowKey] = taxAmt;
        newRowTotal[rowKey] = total;
      }
    });

    setRowTax(newRowTax);
    setRowTaxAmount(newRowTaxAmount);
    setRowTotal(newRowTotal);
  }, [roomDetails]);

  const calculateNights = (checkInIso, checkOutIso) => {
    // checkInIso / checkOutIso 
    if (!checkInIso || !checkOutIso) return 0;

    // agar API se full ISO milta hai, pehle date part lo (yyyy-mm-dd)
    const inDateStr = checkInIso.split("T")[0];
    const outDateStr = checkOutIso.split("T")[0];

    // create Date objects at midnight to avoid timezone shifts
    const inDate = new Date(inDateStr + "T00:00:00");
    const outDate = new Date(outDateStr + "T00:00:00");

    const diffMs = outDate.getTime() - inDate.getTime();
    if (isNaN(diffMs) || diffMs <= 0) return 0;

    const days = Math.round(diffMs / (24 * 60 * 60 * 1000));
    return days;
  };


  const [formData, setFormData] = useState({
    Title: "Mr.",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    EmailAddress: [],
    Address: "",
    MobileNumber: "",
    Country: "",
    State: "",
    City: "",
    CompanyName: "",
    RegistrationNumber: "",
    RegistrationCompanyName: "",
    RegistrationCompanyAddress: "",

    BillingInstruction: "",
    MarketSegment: "",
    BusinessSource: "",
    GuaranteeCodes: "",
    BookingComment: "",
    PaymentComment: "",
  });



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { Title, FirstName, LastName, MobileNumber, BillingInstruction,
      MarketSegment,
      BusinessSource,
      GuaranteeCodes,
      BookingComment,
      PaymentComment, } = formData;

    if (!Title || !FirstName || !LastName || !MobileNumber) {
      swal("Please fill all guest details ", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });
      setLoading(false);
      return;
    }

    if (!BillingInstruction) {
      swal("Please select Billing Instruction", { icon: "warning" });
      return setLoading(false);
    }

    if (!MarketSegment) {
      swal("Please select Market Segment", { icon: "warning" });
      return setLoading(false);
    }

    if (!BusinessSource) {
      swal("Please select Business Source", { icon: "warning" });
      return setLoading(false);
    }

    if (!GuaranteeCodes) {
      swal("Please select Guarantee Code", { icon: "warning" });
      return setLoading(false);
    }

    if (!BookingComment) {
      swal("Please Enter Booking Comment", { icon: "warning" });
      return setLoading(false);
    }

    if (!PaymentComment) {
      swal("Please Enter Payment Comment", { icon: "warning" });
      return setLoading(false);
    }


    if (
      (masterDetails?.RateCode === "Travel Agent" ||
        masterDetails?.RateCode === "Corporate") &&
      (!formData.RegistrationNumber ||
        !formData.RegistrationCompanyName ||
        !formData.RegistrationCompanyAddress)
    ) {
      swal("Please enter Registration Number, Company Name and Company Address.", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });
      setLoading(false);
      return;
    }


    // Check if any room amount is 0 or less
    const hasZeroOrInvalidAmount = roomDetails
      .flatMap((room, roomIdx) =>
        Array.from({ length: room.TotalRoom || 1 }, (_, index) => {
          const rowKey = `${roomIdx}-${index}`;

          const defaultAmount =
            room.Amount ??
            (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0));

          const finalAmount =
            savedAmounts[rowKey] ?? defaultAmount ?? 0;

          return Number(finalAmount);
        })
      )
      .some(amount => amount <= 0);   // yaha condition hai

    if (hasZeroOrInvalidAmount) {
      swal("Room amount must be greater than 0.", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });
      setLoading(false);
      return;
    }


    // 🚨 FINAL SAFETY CHECK BEFORE SUBMIT
    const hasInvalidRoomRate = roomDetails.some((room, roomIdx) => {
      const totalInstances = room.TotalRoom || 1;

      return Array.from({ length: totalInstances }).some((_, index) => {
        const rowKey = `${roomIdx}-${index}`;

        const finalAmount =
          savedAmounts[rowKey] ??
          room.RoomRate ??
          room.Amount ??
          0;

        return Number(finalAmount) <= 0;
      });
    });

    if (hasInvalidRoomRate) {
      swal("One or more rooms have Room Rate 0. Please update before submitting.", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });

      setLoading(false);
      return;
    }


    // 🔎 FINAL API CHECK FOR ROOM RATE
    try {
      const latestData = await GetPreBookingRoomdetail();

      if (latestData?.RoomDetails?.length) {

        const hasZeroRoomRate = latestData.RoomDetails.some(
          (room) => Number(room.RoomRate || room.PerRoomRate) <= 0
        );

        if (hasZeroRoomRate) {
          swal("Something Wrong. Room Rate is 0.", {
            icon: "error",
            buttons: {
              confirm: {
                text: "OK",
                className: "btn btn-danger",
              },
            },
          });

          setLoading(false);
          return;
        }

      } else {
        swal("Something Wrong", {
          icon: "error",
        });
        setLoading(false);
        return;
      }

    } catch (err) {
      console.error("Error checking RoomRate", err);

      swal("Something Wrong", {
        icon: "error",
      });

      setLoading(false);
      return;
    }


    const payload = {
      PreBookingToken: masterDetails?.PreBookingToken,
      TotalRoomRate: baseAmount,
      TotalExtraBedCharges: 0,
      TotalPayment: baseAmount,
      Tax: tax,
      TotalAfterTax: finalTotalAfterTax,
      Discount: 0,
      ...formData,
    };

    // console.log("booking data", payload);

    try {
      await PropeortyBookingConfirm(payload);

      swal("Your booking details submitted to Hotel", {
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-success",
          },
        },
      }).then(() => {
        navigate("/Property/Bookinglist", { state: { showSuccess: true } });
      });

    } catch (error) {
      swal("Booking Failed.", {
        icon: "error",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-danger",
          },
        },
      });
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteRoom = (roomId) => {
    if (!roomId) {
      alert("Missing Room ID.");
      return;
    }

    swal({
      title: "Are you sure ?",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
          className: "btn btn-danger",
          closeModal: true,
        },
        confirm: {
          text: "Yes, delete it",
          className: "btn btn-success",
        },
      },
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;

      setLoading(true);

      try {
        // Optionally call API to delete room on backend
        const result = await DeletePreBookingRoom(roomId, masterDetails?.PreBookingToken);

        if (result?.PreBookingToken) {
          // Remove room from local state only
          const updatedRooms = roomDetails.filter(r => r.ID !== roomId);
          setRoomDetails(updatedRooms);

          // Recalculate total amount
          const amount = updatedRooms.reduce(
            (acc, r) => acc + (r.Amount !== undefined ? r.Amount : (r.TotalRoom * r.RoomRate + (r.ExtraBedAmount || 0))),
            0
          );
          setTotalAmount(amount);

          // Recalculate tax
          const taxPercent = tax; // keep existing tax percent
          const taxAmt = (amount * taxPercent) / 100;
          setTaxAmount(taxAmt);
          setTotalAfterTax(amount + taxAmt);

          // Optional: alert user
          // alert("Room deleted successfully");
        } else {
          alert("Failed to delete room.");
        }
      } catch (error) {
        console.error("Error deleting room:", error);
        alert("Something went wrong while deleting the room.");
      } finally {
        setLoading(false);
      }
    });
  };



  // add room api 
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const result = await roomlistdetail();
        if (result && Array.isArray(result)) {
          setRooms(result);
        }
      } catch (err) {
        console.error("Error fetching rooms:", err);
      }
    };
    fetchRooms();
  }, []);

  // jab room change hoga → uske meal plans nikalenge
  const handleRoomChange = (e) => {
    const roomId = e.target.value;
    const room = rooms.find((r) => r.RoomID.toString() === roomId);
    setSelectedRoom(room);

    // reset rate/meal selections
    setSelectedMealPlan(null);
    setSelectedRatePlan(null);

    if (room?.RatePlanDetails) {
      try {
        // parse JSON string
        const parsedPlans = JSON.parse(room.RatePlanDetails);
        // Optionally normalize the keys (some entries use 'MeelPlan' spelling)
        const normalized = parsedPlans.map(p => ({
          RatePlanID: p.RatePlanID,
          RatePlan: p.RatePlan,
          MealPlan: p.MeelPlan ?? p.MealPlan ?? ""   // prefer MeelPlan if present
        }));
        setMealPlans(normalized);
      } catch (err) {
        console.error("Error parsing RatePlanDetails :", err);
        setMealPlans([]);
      }
    } else {
      setMealPlans([]);
    }
  };


  const resetForm = () => {
    setSelectedRoom(null);
    setMealPlans([]);
    setSelectedMealPlan(null);
    setRoomAmount(0);
    setAdults("0");
    setChildren("0");
    setExtraBed("0");
  };

  useEffect(() => {
    if (!roomDetails || !roomDetails.length) return;

    const newTotal = roomDetails.reduce((acc, r) => {
      const roomRate = Number(r.RoomRate || r.Amount || 0);
      const extraBed = Number(r.ExtraBedAmount || 0);
      const totalRoomCount = Number(r.TotalRoom || 1);
      return acc + totalRoomCount * roomRate + extraBed;
    }, 0);

    setTotalAmount(newTotal);

    const taxPercent = newTotal < 7500 ? 5 : 18;
    setTax(taxPercent);

    const calculatedTaxAmount = (newTotal * taxPercent) / 100;
    setTaxAmount(calculatedTaxAmount);

    setTotalAfterTax(newTotal + calculatedTaxAmount);
  }, [roomDetails]);




  // const handleAddRoomSave = async () => {
  //   if (!selectedRoom) {
  //     swal("Please select a room type!", {
  //       icon: "warning",
  //       buttons: {
  //         confirm: {
  //           text: "OK",
  //           className: "btn btn-warning",
  //         },
  //       },
  //     });
  //     return;
  //   }

  //   const preBookingToken = localStorage.getItem("PreBookingToken");

  //   const baseRoomRate = Number(roomAmount) || 0;
  //   const extraBedAmount = 1500 * Number(extraBed);

  //   const formData = new FormData();
  //   formData.append("ID", "0");
  //   formData.append("PreBookingToken", preBookingToken);
  //   formData.append("RoomID", selectedRoom.RoomID);
  //   formData.append("RatePlanID", selectedMealPlan?.RatePlanID || 0);
  //   formData.append("TotalRoom", "1");
  //   formData.append("RoomRate", baseRoomRate);
  //   formData.append("ExtraBed", extraBed);
  //   formData.append("ExtraBedAmount", extraBedAmount);
  //   formData.append("Adults", adults);
  //   formData.append("Child", children);
  //   formData.append("MealPlanID",);

  //   try {
  //     setLoading(true);
  //     const result = await SavePreBookingRoomAdd(formData);
  //     console.log("Room added successfully", result);

  //     swal("Room added successfully!", {
  //       icon: "success",
  //       buttons: {
  //         confirm: {
  //           text: "OK",
  //           className: "btn btn-success",
  //         },
  //       },
  //     }).then(async () => {
  //       const modalElement = document.getElementById("con-close-modal");
  //       if (modalElement) {
  //         const modal = window.bootstrap.Modal.getInstance(modalElement);
  //         if (modal) modal.hide();
  //       }

  //       resetForm();

  //       const updatedBooking = await GetPreBookingRoomdetail();
  //       if (Array.isArray(updatedBooking?.RoomDetails)) {
  //         setRoomDetails(updatedBooking.RoomDetails);
  //       }
  //     });

  //   } catch (error) {
  //     console.error("Error adding room", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // get market segment

  // edit button click

  const handleAddRoomSave = async () => {
    if (!selectedRoom) {
      swal("Please select a room type", {
        icon: "warning",
        buttons: {
          confirm: { text: "OK", className: "btn btn-warning" },
        },
      });
      return;
    }

    const preBookingToken = localStorage.getItem("PreBookingToken");

    const totalRooms = Number(1);
    const baseRoomRate = Number(roomAmount) || 0;
    const extraBedCount = Number(extraBed) || 0;
    const EXTRA_BED_PRICE = 1500;
    const extraBedAmount = EXTRA_BED_PRICE * extraBedCount * totalRooms;

    const adultsCount = Number(adults) || 0;
    const childrenCount = Number(children) || 0;

    const formData = new FormData();
    formData.append("ID", "0");
    formData.append("PreBookingToken", preBookingToken);
    formData.append("RoomID", selectedRoom.RoomID);
    formData.append("RatePlanID", selectedRateCode || "");
    formData.append("TotalRoom", totalRooms.toString());
    formData.append("RoomRate", baseRoomRate.toString());
    formData.append("ExtraBed", extraBedCount.toString());
    formData.append("ExtraBedAmount", extraBedAmount.toString());
    formData.append("Adults", adultsCount.toString());
    formData.append("Child", childrenCount.toString());
    formData.append("MealPlanID", selectedMealPlan || "");

    try {
      setLoading(true);
      const result = await SavePreBookingRoomAdd(formData);
      console.log("Room added successfully", result);

      swal("Room added successfully", {
        icon: "success",
        buttons: {
          confirm: { text: "OK", className: "btn btn-success" },
        },
      }).then(async () => {
        const modalElement = document.getElementById("con-close-modal");
        if (modalElement) {
          const modal = window.bootstrap.Modal.getInstance(modalElement);
          if (modal) modal.hide();
        }
        resetForm();
        const updatedBooking = await GetPreBookingRoomdetail();
        if (Array.isArray(updatedBooking?.RoomDetails)) {
          setRoomDetails(updatedBooking.RoomDetails);
        }
      });
    } catch (error) {
      console.error("Error adding room", error);
    } finally {
      setLoading(false);
    }
  };


  // const handleEditClick = (rowKey, initialAmount) => {
  //   setEditingRowKey(rowKey);
  //   setTempAmount(prev => ({ ...prev, [rowKey]: initialAmount }));
  // };

  const handleEditClick = (rowKey, initialAmount) => {
    setEditingRowKey(rowKey);

    setTempAmount(prev => ({
      ...prev,
      [rowKey]: initialAmount
    }));

    //  default tax = 5% if not already set
    setRowTax(prev => ({
      ...prev,
      [rowKey]: prev[rowKey] ?? 5
    }));

    //  immediately calculate tax & total
    calculateRowAmounts(rowKey, initialAmount, 5);
  };


  // input change (local only)
  const handleAmountInputChange = (rowKey, value) => {
    // allow empty string while editing to let user clear input
    // const numericValue = value === "" ? "" : parseFloat(value);
    setTempAmount(prev => ({ ...prev, [rowKey]: value }));
  };

  const handleCancelClick = () => {
    setEditingRowKey(null);
  };

  const handleSaveClick = async (rowKey, room, instanceIndex) => {
    // 🔹 Amount typed in input
    const typedVal = tempAmount[rowKey];
    const numericValue =
      typedVal === "" || typedVal === undefined ? 0 : Number(typedVal);

    if (numericValue <= 0) {
      swal("Amount must be greater than 0", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });
      return; // ❌ stop saving
    }

    // 🔹 1. SAVE AMOUNT (COMMIT)
    setSavedAmounts(prev => ({
      ...prev,
      [rowKey]: numericValue,
    }));

    // 🔹 2. SAVE TAX ONLY FOR THIS ROW (COMMIT)
    const selectedTaxAmount = Number(rowTaxAmount[rowKey] ?? 0);

    setSavedRowTaxAmount(prev => ({
      ...prev,
      [rowKey]: selectedTaxAmount,
    }));

    // 🔹 3. Prepare API payload
    // const preBookingToken = localStorage.getItem("PreBookingToken") || "";
    // const formData = new FormData();

    // formData.append("ID", room.ID || "N/A");
    // formData.append("PreBookingToken", preBookingToken);
    // formData.append("RoomID", room.RoomID);
    // formData.append("RatePlanID", room.RatePlanID || "");
    // formData.append("TotalRoom", room.TotalRoom || 1);
    // formData.append("RoomRate", numericValue);
    // formData.append("ExtraBed", room.ExtraBed || 0);
    // formData.append("ExtraBedAmount", room.ExtraBedAmount || 0);
    // formData.append("Adults", room.Adults || 0);
    // formData.append("Child", room.Child || 0);
    // formData.append("MealPlanID", room.MealPlanID || "Null");
    // formData.append("Tax", Number(rowTax[rowKey] ?? 0));
    // formData.append("TaxRate", selectedTaxAmount);
    // formData.append("NetAmount", numericValue + selectedTaxAmount);

    // try {
    //   const result = await SavePreBookingRoomAdd(formData);

    //   if (result?.RoomDetails) {
    //     setRoomDetails(result.RoomDetails);
    //   }

    //   swal("Amount updated successfully", {
    //     icon: "success",
    //     buttons: { confirm: { text: "OK", className: "btn btn-success" } },
    //   });



    // } catch (error) {
    //   console.error("Error saving room data:", error);
    // }


    const preBookingToken = localStorage.getItem("PreBookingToken") || "";

    try {

      // 🔥 COPY MODE + FIRST ROW → SAVE ALL ROWS
      if (isCopied && rowKey === "0-0") {

        for (let roomIdx = 0; roomIdx < roomDetails.length; roomIdx++) {
          const roomItem = roomDetails[roomIdx];
          const total = roomItem.TotalRoom || 1;

          for (let i = 0; i < total; i++) {

            const key = `${roomIdx}-${i}`;

            const amt =
              key === rowKey
                ? numericValue
                : savedAmounts[key] ?? (roomItem.Amount ?? roomItem.RoomRate);

            const taxRate = Number(rowTax[key] ?? 0);
            const taxAmount = Number(rowTaxAmount[key] ?? 0);

            // 🔹 local state update
            setSavedAmounts(prev => ({ ...prev, [key]: amt }));
            setSavedRowTaxAmount(prev => ({ ...prev, [key]: taxAmount }));

            // 🔹 API payload
            const formData = new FormData();

            formData.append("ID", roomItem.ID || "N/A");
            formData.append("PreBookingToken", preBookingToken);
            formData.append("RoomID", roomItem.RoomID);
            formData.append("RatePlanID", roomItem.RatePlanID || "");
            formData.append("TotalRoom", roomItem.TotalRoom || 1);
            formData.append("RoomRate", amt);
            formData.append("ExtraBed", roomItem.ExtraBed || 0);
            formData.append("ExtraBedAmount", roomItem.ExtraBedAmount || 0);
            formData.append("Adults", roomItem.Adults || 0);
            formData.append("Child", roomItem.Child || 0);
            formData.append("MealPlanID", roomItem.MealPlanID || "Null");
            formData.append("Tax", taxRate);
            formData.append("TaxRate", taxAmount);
            formData.append("NetAmount", amt + taxAmount);

            await SavePreBookingRoomAdd(formData);
          }
        }

      } else {
        // ✅ NORMAL SINGLE ROW SAVE

        const selectedTaxAmount = Number(rowTaxAmount[rowKey] ?? 0);

        setSavedAmounts(prev => ({
          ...prev,
          [rowKey]: numericValue,
        }));

        setSavedRowTaxAmount(prev => ({
          ...prev,
          [rowKey]: selectedTaxAmount,
        }));

        const formData = new FormData();

        formData.append("ID", room.ID || "N/A");
        formData.append("PreBookingToken", preBookingToken);
        formData.append("RoomID", room.RoomID);
        formData.append("RatePlanID", room.RatePlanID || "");
        formData.append("TotalRoom", room.TotalRoom || 1);
        formData.append("RoomRate", numericValue);
        formData.append("ExtraBed", room.ExtraBed || 0);
        formData.append("ExtraBedAmount", room.ExtraBedAmount || 0);
        formData.append("Adults", room.Adults || 0);
        formData.append("Child", room.Child || 0);
        formData.append("MealPlanID", room.MealPlanID || "Null");
        formData.append("Tax", Number(rowTax[rowKey] ?? 0));
        formData.append("TaxRate", selectedTaxAmount);
        formData.append("NetAmount", numericValue + selectedTaxAmount);

        const result = await SavePreBookingRoomAdd(formData);

        if (result?.RoomDetails) {
          setRoomDetails(result.RoomDetails);
        }
      }

      swal("Amount updated successfully", {
        icon: "success",
        buttons: { confirm: { text: "OK", className: "btn btn-success" } },
      });

    } catch (error) {
      console.error("Error saving room data:", error);
    }
    
    // 🔹 4. Exit edit mode
    setEditingRowKey(null);
  };

  useEffect(() => {
    const fetchSegments = async () => {
      try {
        setLoading(true);
        const data = await PropertyMarketSegmentApi();
        if (data) {
          setMarketSegments(data);
        }
      } catch (err) {
        console.error("Error fetching market segments", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSegments();
  }, []);


  // get Business Source
  useEffect(() => {
    const fetchBusinessSources = async () => {
      try {
        const data = await PropertyBusinessSourceList();
        if (data && Array.isArray(data)) {
          setBusinessSources(data);
        }
      } catch (error) {
        console.error("Error fetching business sources", error);
      }
    };
    fetchBusinessSources();
  }, []);


  useEffect(() => {
    const FetchPMS = async () => {
      try {
        const result = await getBasicPropertydetails();
        if (result && result.length > 0) {
          setPMS(result[0]);
        }
      }
      catch (error) {
        console.log("error fetch Pms in get api", error);
      }
    }
    FetchPMS();
  }, [])


  useEffect(() => {
    const fetchGuaranteeCodes = async () => {
      setLoading(true);
      try {
        const data = await PropertyGuaranteeCodes();
        if (Array.isArray(data)) setGuaranteeCodes(data);
      } catch (error) {
        console.log("Error fetching gurantee Codes:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGuaranteeCodes();
  }, []);


  useEffect(() => {
    const fetchRatecode = async () => {
      setLoading(true);
      try {
        const result = await PropertyRateCode();
        if (Array.isArray(result)) setRatecode(result);
      } catch (error) {
        console.log("error get rate code", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRatecode();
  }, []);

  useEffect(() => {
    const FetchMealplan = async () => {
      setLoading(true);
      try {
        const result = await PropertyMealplan();
        if (Array.isArray(result)) setMealplan(result);

      } catch (error) {
        console.log("error get meal plan", error);
      } finally {
        setLoading(false);
      }
    };
    FetchMealplan();
  }, []);

  const calculateRowAmounts = (rowKey, amount, taxPercent) => {
    const taxAmt = (Number(amount) * Number(taxPercent || 0)) / 100;
    const total = Number(amount) + taxAmt;

    setRowTaxAmount(prev => ({
      ...prev,
      [rowKey]: taxAmt,
    }));

    setRowTotal(prev => ({
      ...prev,
      [rowKey]: total,
    }));
  };



  const nights = calculateNights(
    masterDetails?.CheckInDate,
    masterDetails?.CheckOutDate
  ) || 0;


  // ✅ BASE AMOUNT = sab rows ke amount ka sum
  const baseAmount = roomDetails
    .flatMap((room, roomIdx) =>
      Array.from({ length: room.TotalRoom || 1 }, (_, index) => {
        const rowKey = `${roomIdx}-${index}`;

        // per night amount
        const perNightAmount =
          room.Amount ??
          (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0));

        return Number(savedAmounts[rowKey] ?? perNightAmount ?? 0);
      })
    )
    .reduce((sum, val) => sum + Number(val), 0) * nights;



  // ✅ FINAL TAX AMOUNT = sab rows ke tax ka sum
  // const finalTaxAmount =
  //   Object.values(savedRowTaxAmount).reduce(
  //     (sum, val) => sum + Number(val || 0),
  //     0
  //   ) * nights;

  const finalTaxAmount =
    Object.values(rowTaxAmount).reduce(
      (sum, val) => sum + Number(val || 0),
      0
    ) * nights;

  const finalTotalAfterTax = baseAmount + finalTaxAmount;


  // const handleCopyToAll = async (amount) => {
  //   const newSaved = {};
  //   const preBookingToken = localStorage.getItem("PreBookingToken") || "";

  //   try {
  //     for (const [roomIdx, room] of roomDetails.entries()) {
  //       const total = room.TotalRoom || 1;

  //       for (let i = 0; i < total; i++) {
  //         const key = `${roomIdx}-${i}`;
  //         newSaved[key] = amount;

  //         const taxPercent = Number(rowTax[key] ?? 5);
  //         const taxAmt = (amount * taxPercent) / 100;

  //         // ✅ Row calculation update
  //         calculateRowAmounts(key, amount, taxPercent);

  //         // ✅ API CALL FOR EACH ROW
  //         const formData = new FormData();
  //         formData.append("ID", room.ID || "N/A");
  //         formData.append("PreBookingToken", preBookingToken);
  //         formData.append("RoomID", room.RoomID);
  //         formData.append("RatePlanID", room.RatePlanID || "");
  //         formData.append("TotalRoom", room.TotalRoom || 1);
  //         formData.append("RoomRate", amount);
  //         formData.append("ExtraBed", room.ExtraBed || 0);
  //         formData.append("ExtraBedAmount", room.ExtraBedAmount || 0);
  //         formData.append("Adults", room.Adults || 0);
  //         formData.append("Child", room.Child || 0);
  //         formData.append("MealPlanID", room.MealPlanID || "Null");
  //         formData.append("Tax", taxPercent);
  //         formData.append("TaxRate", taxAmt);
  //         formData.append("NetAmount", amount + taxAmt);

  //         await SavePreBookingRoomAdd(formData); // 🔥 IMPORTANT
  //       }
  //     }

  //     // ✅ UI update after all API calls
  //     setSavedAmounts(newSaved);
  //     setCopiedAmount(amount);
  //     setIsCopied(true);

  //     swal("All rows updated successfully", {
  //       icon: "success",
  //       buttons: {
  //         confirm: {
  //           text: "OK",
  //           className: "btn btn-success",
  //         },
  //       },
  //     });

  //   } catch (error) {
  //     console.error("Bulk save error:", error);

  //     swal("Error while saving copied data", {
  //       icon: "error",
  //     });
  //   }
  // };

  const handleCopyToAll = async (amount) => {
    const newSaved = {};
    const newTax = {};
    const preBookingToken = localStorage.getItem("PreBookingToken") || "";

    try {
      const firstRowKey = "0-0"; // 🔥 FIRST ROW
      const globalTax = Number(rowTax[firstRowKey] ?? 5); // 👈 yahi main fix hai

      for (const [roomIdx, room] of roomDetails.entries()) {
        const total = room.TotalRoom || 1;

        for (let i = 0; i < total; i++) {
          const key = `${roomIdx}-${i}`;

          newSaved[key] = amount;
          newTax[key] = globalTax; // 🔥 TAX COPY

          const taxAmt = (amount * globalTax) / 100;

          // ✅ UI calculation
          calculateRowAmounts(key, amount, globalTax);

          // ✅ API CALL
          const formData = new FormData();
          formData.append("ID", room.ID || "N/A");
          formData.append("PreBookingToken", preBookingToken);
          formData.append("RoomID", room.RoomID);
          formData.append("RatePlanID", room.RatePlanID || "");
          formData.append("TotalRoom", room.TotalRoom || 1);
          formData.append("RoomRate", amount);
          formData.append("ExtraBed", room.ExtraBed || 0);
          formData.append("ExtraBedAmount", room.ExtraBedAmount || 0);
          formData.append("Adults", room.Adults || 0);
          formData.append("Child", room.Child || 0);
          formData.append("MealPlanID", room.MealPlanID || "Null");
          formData.append("Tax", globalTax); // 🔥 FIXED
          formData.append("TaxRate", taxAmt);
          formData.append("NetAmount", amount + taxAmt);

          await SavePreBookingRoomAdd(formData);
        }
      }

      // ✅ FINAL UI UPDATE
      setSavedAmounts(newSaved);
      setRowTax(newTax); // 🔥 VERY IMPORTANT
      setCopiedAmount(amount);
      setIsCopied(true);

      swal("All rows updated successfully", {
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-success",
          },
        },
      });

    } catch (error) {
      console.error("Bulk save error:", error);

      swal("Error while saving copied data", {
        icon: "error",
      });
    }
  };

  // const handleRemoveCopy = async () => {
  //   const newSaved = {};
  //   const preBookingToken = localStorage.getItem("PreBookingToken") || "";

  //   try {
  //     for (const [roomIdx, room] of roomDetails.entries()) {
  //       const total = room.TotalRoom || 1;

  //       for (let i = 0; i < total; i++) {
  //         const key = `${roomIdx}-${i}`;

  //         // 🔹 ORIGINAL AMOUNT
  //         const originalAmount =
  //           room.Amount ??
  //           (room.RoomRate || 0);

  //         newSaved[key] = originalAmount;

  //         // 🔹 TAX CALCULATION
  //         const taxPercent = originalAmount < 7500 ? 5 : 18;
  //         const taxAmt = (originalAmount * taxPercent) / 100;

  //         // 🔹 UI UPDATE
  //         calculateRowAmounts(key, originalAmount, taxPercent);

  //         // 🔹 API CALL (IMPORTANT 🔥)
  //         const formData = new FormData();
  //         formData.append("ID", room.ID || "N/A");
  //         formData.append("PreBookingToken", preBookingToken);
  //         formData.append("RoomID", room.RoomID);
  //         formData.append("RatePlanID", room.RatePlanID || "");
  //         formData.append("TotalRoom", room.TotalRoom || 1);
  //         formData.append("RoomRate", originalAmount);
  //         formData.append("ExtraBed", room.ExtraBed || 0);
  //         formData.append("ExtraBedAmount", room.ExtraBedAmount || 0);
  //         formData.append("Adults", room.Adults || 0);
  //         formData.append("Child", room.Child || 0);
  //         formData.append("MealPlanID", room.MealPlanID || "Null");
  //         formData.append("Tax", taxPercent);
  //         formData.append("TaxRate", taxAmt);
  //         formData.append("NetAmount", originalAmount + taxAmt);

  //         await SavePreBookingRoomAdd(formData);
  //       }
  //     }

  //     // 🔹 FINAL UI RESET
  //     setSavedAmounts(newSaved);
  //     setCopiedAmount(null);
  //     setIsCopied(false);

  //     swal("Copy removed successfully", {
  //       icon: "success",
  //     });

  //   } catch (error) {
  //     console.error("Error removing copy:", error);

  //     swal("Error while removing copied data", {
  //       icon: "error",
  //     });
  //   }
  // };

  const handleRemoveCopy = async () => {
    const newSaved = {};
    const newTax = {}; // 🔥 ADD THIS
    const preBookingToken = localStorage.getItem("PreBookingToken") || "";

    try {
      for (const [roomIdx, room] of roomDetails.entries()) {
        const total = room.TotalRoom || 1;

        for (let i = 0; i < total; i++) {
          const key = `${roomIdx}-${i}`;

          // 🔹 ORIGINAL AMOUNT
          const originalAmount =
            room.Amount ??
            (room.RoomRate || 0);

          newSaved[key] = originalAmount;

          // 🔹 TAX RESET
          const taxPercent = originalAmount < 7500 ? 5 : 18;
          newTax[key] = taxPercent; // 🔥 IMPORTANT

          const taxAmt = (originalAmount * taxPercent) / 100;

          // 🔹 UI UPDATE
          calculateRowAmounts(key, originalAmount, taxPercent);

          // 🔹 API CALL
          const formData = new FormData();
          formData.append("ID", room.ID || "N/A");
          formData.append("PreBookingToken", preBookingToken);
          formData.append("RoomID", room.RoomID);
          formData.append("RatePlanID", room.RatePlanID || "");
          formData.append("TotalRoom", room.TotalRoom || 1);
          formData.append("RoomRate", originalAmount);
          formData.append("ExtraBed", room.ExtraBed || 0);
          formData.append("ExtraBedAmount", room.ExtraBedAmount || 0);
          formData.append("Adults", room.Adults || 0);
          formData.append("Child", room.Child || 0);
          formData.append("MealPlanID", room.MealPlanID || "Null");

          formData.append("Tax", taxPercent);
          formData.append("TaxRate", taxAmt);
          formData.append("NetAmount", originalAmount + taxAmt);

          await SavePreBookingRoomAdd(formData);
        }
      }

      // 🔥 FINAL UI RESET
      setSavedAmounts(newSaved);
      setRowTax(newTax); // 🔥 THIS FIXES DROPDOWN
      setCopiedAmount(null);
      setIsCopied(false);

      swal("Copy removed successfully", {
        icon: "success",
      });

    } catch (error) {
      console.error("Error removing copy:", error);

      swal("Error while removing copied data", {
        icon: "error",
      });
    }
  };

  return (
    <>
      <style> {`
        th {
          background-color:#a2a7b7 !important;
          color: #fff !important;
        }
          .table td {
    border-bottom: 0px;
      }

      .property-room-table-wrap {
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }

      .property-room-table {
        width: 100%;
        min-width: 920px;
        table-layout: fixed;
        margin-bottom: 0;
      }

      .property-room-table th,
      .property-room-table td {
        padding: 10px 6px;
        vertical-align: middle;
        white-space: nowrap;
        text-align: center;
        font-size: 13px;
      }

      .property-room-table th {
        font-size: 11px;
        line-height: 1.25;
      }

      .property-room-table .room-type-cell {
        width: 14%;
        white-space: normal;
        overflow-wrap: anywhere;
        text-align: left;
        line-height: 1.35;
      }

      .property-room-table .plan-cell { width: 11%; }
      .property-room-table .count-cell { width: 7%; }
      .property-room-table .amount-cell { width: 16%; }
      .property-room-table .tax-percent-cell { width: 9%; }
      .property-room-table .money-cell { width: 9%; }
      .property-room-table .action-cell { width: 9%; }

      .property-room-table .amount-control {
        flex-wrap: nowrap;
        gap: 4px !important;
      }

      .property-room-table .amount-input {
        width: 76px;
        min-width: 0;
        padding-left: 5px;
        padding-right: 5px;
      }

      .property-room-table .form-select {
        min-width: 60px;
        padding-left: 7px;
        padding-right: 22px;
      }

      @media (max-width: 767.98px) {
        .property-room-table {
          min-width: 860px;
        }

        .property-room-table th,
        .property-room-table td {
          padding: 8px 5px;
          font-size: 12px;
        }
      }
      `}
      </style>

      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card mb-0 ">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Property Room Details</h4>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">Arrival:</label>
                              <input type="date" className="form-control" value={masterDetails?.CheckInDate?.split("T")[0] || ""} readOnly />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Departure:
                              </label>
                              <input type="date" className="form-control" value={masterDetails?.CheckOutDate?.split("T")[0] || ""} readOnly />
                            </div>
                          </div>

                          <div className="col-md-1 mb-3">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Nights
                              </label>
                              <input type='text' className='form-control'
                                value={calculateNights(masterDetails?.CheckInDate, masterDetails?.CheckOutDate) || 0}
                                readOnly />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Rate Code:
                              </label>
                              <select className="form-control form-select" value={masterDetails?.RateCode || ''} disabled>
                                <option value="">{masterDetails?.RateCode || "Select Type"}</option>
                              </select>
                            </div>
                          </div>





                          {/*hotel rooom table */}

                          <div className="col-md-12">
                            <div className="table-responsive property-room-table-wrap">
                              <div className='text-end'>
                                {/* <button type="button" className="btn btn-sm btn-primary mb-2 " data-bs-toggle="modal" data-bs-target="#con-close-modal"> <i className='fas fa-plus'></i> ADD </button> */}
                              </div>
                              <table className="display table table-bordered property-room-table" >
                                <thead>
                                  <tr >
                                    <th className='th room-type-cell'> Room Type </th>

                                    {Pms?.PMS === "Opera" && (<th className="plan-cell">Rate Plan</th>)}
                                    <th className="plan-cell"> Meal Plan </th>
                                    {/* <th>  Rooms </th> */}
                                    <th className="count-cell"> Adult's</th>
                                    <th className="count-cell">Child's</th>
                                    <th className="count-cell"> Extra <br /> Bed's</th>
                                    <th className='text-center amount-cell'> Amount </th>
                                    <th className="tax-percent-cell">Tax %</th>
                                    <th className="money-cell">Tax</th>
                                    <th className="money-cell">Total</th>
                                    <th className="action-cell"> Action </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {roomDetails.flatMap((room, roomIdx) =>
                                    Array.from({ length: room.TotalRoom || 1 }, (_, index) => {
                                      const rowKey = `${roomIdx}-${index}`; // UNIQUE per rendered row (even if same RoomID)

                                      const isFirstRow = roomIdx === 0 && index === 0;

                                      const defaultAmount = room.Amount ?? (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0));

                                      const displayedValue =
                                        editingRowKey === rowKey
                                          ? (tempAmount[rowKey] ?? defaultAmount)
                                          : (savedAmounts[rowKey] ?? defaultAmount);

                                      return (
                                        <tr key={rowKey}>
                                          <td className="room-type-cell">{room.RoomName}</td>
                                          {Pms?.PMS === "Opera" && <td className="plan-cell">{room.RatePlan}</td>}
                                          <td className="plan-cell">{room.MealPlan}</td>
                                          <td className="text-center">{room.Adults}</td>
                                          <td className="text-center">{room.Child}</td>
                                          <td className="text-center">{room.ExtraBed}</td>

                                          <td className="text-center amount-cell">
                                            <div className="d-flex align-items-center justify-content-center amount-control">

                                              <input
                                                type="text"
                                                min="1"
                                                step="1"
                                                readOnly={editingRowKey !== rowKey}
                                                value={displayedValue}
                                                onChange={(e) => {
                                                  const val = e.target.value;

                                                  handleAmountInputChange(rowKey, val);

                                                  const selectedTax = rowTax[rowKey] ?? 0;
                                                  calculateRowAmounts(rowKey, val, selectedTax);
                                                }}

                                                onBlur={() => {
                                                  if (editingRowKey === rowKey) {
                                                    handleSaveClick(rowKey, room, index);
                                                  }
                                                }}
                                                className="form-control text-center amount-input"
                                              />

                                              {/* 🔥 COPY BUTTON ONLY FIRST ROW */}
                                              {isFirstRow && (
                                                isCopied ? (
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm text-danger"
                                                    onClick={handleRemoveCopy}
                                                    title="Remove Copy"
                                                  >
                                                    Not Copy
                                                  </button>
                                                ) : (
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm text-primary"
                                                    onClick={() => handleCopyToAll(displayedValue)}
                                                    title="Copy to all"
                                                  >
                                                    Copy
                                                  </button>
                                                )
                                              )}

                                            </div>

                                          </td>

                                          <td>
                                            <select
                                              className="form-select"
                                              disabled={editingRowKey !== rowKey}
                                              value={rowTax[rowKey] ?? ""}
                                              // onChange={(e) => {
                                              //   const taxVal = e.target.value;
                                              //   setRowTax(prev => ({ ...prev, [rowKey]: taxVal }));

                                              //   const amt =
                                              //     editingRowKey === rowKey
                                              //       ? tempAmount[rowKey] ?? defaultAmount
                                              //       : displayedValue;

                                              //   calculateRowAmounts(rowKey, amt, taxVal);
                                              // }}

                                              onChange={(e) => {
                                                const taxVal = Number(e.target.value);

                                                // 🔥 FIRST ROW CONTROL (ONLY WHEN COPIED)
                                                if (isCopied && rowKey === "0-0") {

                                                  const newTax = {};

                                                  roomDetails.forEach((room, roomIdx) => {
                                                    const total = room.TotalRoom || 1;

                                                    for (let i = 0; i < total; i++) {
                                                      const key = `${roomIdx}-${i}`;

                                                      newTax[key] = taxVal;

                                                      const amt =
                                                        key === rowKey
                                                          ? tempAmount[key] ?? defaultAmount
                                                          : savedAmounts[key] ?? (room.Amount ?? room.RoomRate);

                                                      calculateRowAmounts(key, amt, taxVal);
                                                    }
                                                  });

                                                  setRowTax(newTax); // 🔥 update all rows

                                                } else {
                                                  // ✅ NORMAL ROW UPDATE
                                                  setRowTax(prev => ({ ...prev, [rowKey]: taxVal }));

                                                  const amt =
                                                    editingRowKey === rowKey
                                                      ? tempAmount[rowKey] ?? defaultAmount
                                                      : displayedValue;

                                                  calculateRowAmounts(rowKey, amt, taxVal);
                                                }
                                              }}

                                              onBlur={() => {
                                                if (editingRowKey === rowKey) {
                                                  handleSaveClick(rowKey, room, index);
                                                }
                                              }}
                                            >
                                              <option value="">Select</option>
                                              <option value={5}>5%</option>
                                              <option value={18}>18%</option>
                                            </select>
                                          </td>

                                          <td className="text-center">
                                            {(rowTaxAmount[rowKey] ?? 0).toFixed(2)}
                                          </td>

                                          <td className="text-center">
                                            {(rowTotal[rowKey] ?? displayedValue).toFixed(2)}
                                          </td>

                                          <td className="text-center">
                                            {editingRowKey === rowKey ? (
                                              <>
                                                {/* SAVE */}
                                                <button
                                                  type="button"
                                                  className="btn p-0 text-success me-3"
                                                  onClick={() => handleSaveClick(rowKey, room, index)}
                                                  title="Save"
                                                >
                                                  <i className="fas fa-check" style={{ fontSize: "16px" }}></i>
                                                </button>

                                                {/* CANCEL */}
                                                <button
                                                  type="button"
                                                  className="btn p-0 text-danger"
                                                  onClick={handleCancelClick}
                                                  title="Cancel"
                                                >
                                                  <i className="fas fa-times" style={{ fontSize: "16px" }}></i>
                                                </button>
                                              </>
                                            ) : (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn p-0"
                                                  onClick={() =>
                                                    handleEditClick(rowKey, savedAmounts[rowKey] ?? defaultAmount)
                                                  }
                                                  title="Edit"
                                                >
                                                  <i className="fas fa-edit me-3"></i>
                                                </button>

                                                <button
                                                  type="button"
                                                  className="btn p-0"
                                                  style={{ color: "red" }}
                                                  onClick={() =>
                                                    handleDeleteRoom(room.ID, masterDetails?.PreBookingToken)
                                                  }
                                                  title="Delete"
                                                >
                                                  <i className="fas fa-trash"></i>
                                                </button>
                                              </div>
                                            )}
                                          </td>

                                        </tr>
                                      );
                                    })
                                  )}
                                </tbody>


                              </table>
                            </div>
                          </div>


                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className="fw-bold position-absolute rounded-2"
                                style={{
                                  top: "-12px",
                                  paddingInline: "8px",
                                  backgroundColor: "#f5f7fd ",
                                  left: "5px",
                                }}
                              >
                                Total Amount{" "}
                              </h6>
                              <div className="row align-items-end p-3">
                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Amount
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={baseAmount.toFixed(2) || "0.00"}
                                      readOnly
                                    />

                                  </div>
                                </div>

                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">+</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <div className="d-flex gap-2 mb-1">
                                      <label className="col-form-label">
                                        Tax
                                      </label>
                                    </div>

                                    <input
                                      type="number"
                                      className="form-control"
                                      value={finalTaxAmount.toFixed(2)}
                                      readOnly
                                    />

                                  </div>

                                </div>


                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">=</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Total Amount After Tax
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={finalTotalAfterTax.toFixed(2)}
                                      readOnly
                                    />

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          {/* guest details table */}

                          <div className="col-md-12">
                            <h4 className="mt-3">Guest Details:</h4>
                            <div className="table-responsive">
                              <table
                                className="display table table-striped table-bordered table-hover"
                                style={{
                                  width: "100%",
                                  tableLayout: "auto",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th>Title</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Contact No </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <select className='form-select form-control' value={formData.Title} onChange={(e) => setFormData({ ...formData, Title: e.target.value })}>
                                        <option>Select Prifix</option>
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                        <option>Ms.</option>
                                        <option>Dr.</option>
                                      </select>
                                    </td>
                                    <td>
                                      <input type="text" className="form-control" placeholder="Enter First Name" value={formData.FirstName} onChange={(e) => setFormData({ ...formData, FirstName: e.target.value })} />
                                    </td>
                                    <td>
                                      <input type="text" className="form-control" placeholder="Enter Last Name" value={formData.LastName} onChange={(e) => setFormData({ ...formData, LastName: e.target.value })} />
                                    </td>
                                    <td>
                                      <input type="number" className="form-control" placeholder="Enter Contact No" value={formData.MobileNumber} onChange={(e) => setFormData({ ...formData, MobileNumber: e.target.value })} />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-block ">
                              <label className="col-form-label">Email:</label>
                              {/* <input type="email" className="form-control" placeholder="Enter Email" value={formData.EmailAddress} onChange={(e) => setFormData({ ...formData, EmailAddress: e.target.value })} /> */}
                              <TagsInput
                                value={formData.EmailAddress}
                                onChange={(emails) => setFormData({ ...formData, EmailAddress: emails })}
                                name="emails"
                                placeHolder="Enter email "
                              />
                              <div className="form-check d-flex">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault"  >
                                  Do want to receive Booking Voucher on email ?
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="col-form-label">Address</label>
                              <textarea
                                type="text"
                                className="form-control"
                                placeholder="Enter Address"
                                value={formData.Address}
                                onChange={(e) => setFormData({ ...formData, Address: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <div className="input-block">
                              <label className="col-form-label">City</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter City"
                                value={formData.City}
                                onChange={(e) => setFormData({ ...formData, City: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">Country</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Country"
                                value={formData.Country}
                                onChange={(e) => setFormData({ ...formData, Country: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">State</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter State"
                                value={formData.State}
                                onChange={(e) => setFormData({ ...formData, State: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">
                                Company Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Company Name"
                                value={formData.CompanyName}
                                onChange={(e) => setFormData({ ...formData, CompanyName: e.target.value })}
                              />
                            </div>
                          </div>

                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className=" fw-bold position-absolute bg-gray1 rounded-2"
                                style={{
                                  top: "-12px",
                                  left: "12px",
                                  paddingInline: "4px",
                                }}
                              >
                                Enter GST Details (Optional)
                              </h6>
                              <div className="row p-3">
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registration Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registration Number"
                                      value={formData.RegistrationNumber}
                                      onChange={(e) => setFormData({ ...formData, RegistrationNumber: e.target.value })}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registred Company Name"
                                      value={formData.RegistrationCompanyName}
                                      onChange={(e) => setFormData({ ...formData, RegistrationCompanyName: e.target.value })}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company address
                                    </label>
                                    <textarea
                                      type="text"
                                      className="form-control"
                                      placeholder="Registered Company Address"
                                      value={formData.RegistrationCompanyAddress}
                                      onChange={(e) => setFormData({ ...formData, RegistrationCompanyAddress: e.target.value })}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Billing Instructions:
                              </label>
                              <select className="form-select form-control" value={formData.BillingInstruction}
                                onChange={(e) =>
                                  setFormData({ ...formData, BillingInstruction: e.target.value })
                                }>
                                <option>Select Billing Instruction</option>
                                <option value="Pay at hotel">Pay at hotel</option>
                                <option value="Prepaid">Prepaid</option>
                                <option value="Send Invoice">Send Invoice</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label" htmlFor="marketSegment">
                                Market Segment
                              </label>
                              <select

                                className="form-select form-control"
                                value={formData.MarketSegment}
                                onChange={(e) =>
                                  setFormData({ ...formData, MarketSegment: e.target.value })
                                }
                              >
                                <option value="">Select</option>
                                {marketSegments &&
                                  marketSegments.map((item) => (
                                    <option key={item.ID} value={item.Code}>
                                      {item.MarketSeg}
                                    </option>
                                  ))}

                              </select>
                            </div>
                          </div>



                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Business Source</label>
                              <select
                                className="form-select form-control"
                                value={formData.BusinessSource}
                                onChange={(e) =>
                                  setFormData({ ...formData, BusinessSource: e.target.value })
                                }
                              >
                                <option value="">Select</option>

                                {businessSources.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.BusinessSource}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>


                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Guarantee Codes
                              </label>
                              <select
                                className="form-select form-control"
                                value={formData.GuaranteeCodes}
                                onChange={(e) =>
                                  setFormData({ ...formData, GuaranteeCodes: e.target.value })
                                }
                              >
                                <option value="">Select</option>
                                {guaranteeCodes.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.guaranteeCodes}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Booking Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Special Requriment"
                                value={formData.BookingComment}
                                onChange={(e) => setFormData({ ...formData, BookingComment: e.target.value })}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Payment Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Payment Comment"
                                value={formData.PaymentComment}
                                onChange={(e) => setFormData({ ...formData, PaymentComment: e.target.value })}
                              ></textarea>
                            </div>
                          </div>

                          {/* <!-- Submit Button --> */}
                          <div className="card-action text-end">
                            <button type="submit" className="btn btn-black">
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <>
          <div
            id="con-close-modal"
            className="modal fade"
            tabIndex={-1}
            role="dialog"
            aria-hidden="true"
            style={{ display: "none" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Add Room</h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body p-4">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label"> ROOM TYPE </label>
                        <select className="form-control form-select" value={selectedRoom?.RoomID || ""} onChange={handleRoomChange}>
                          <option>select type</option>
                          {rooms.map((room) => (
                            <option key={room.RoomID} value={room.RoomID}>
                              {room.RoomName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {Pms?.PMS === "Opera" && (<div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label"> Rate Code </label>
                        <select className="form-select form-control" value={selectedRateCode}
                          onChange={(e) => setSelectedRateCode(e.target.value)}>
                          <option>Select Code</option>

                          {ratecode.map((item) => (
                            <option key={item.RateCodeID} value={item.Code}>
                              {item.Name}
                            </option>
                          ))}
                        </select>

                      </div>
                    </div>)}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label"> MEAL PLAN </label>
                        <select className="form-control form-select" value={selectedMealPlan}
                          onChange={(e) => setSelectedMealPlan(e.target.value)}>
                          <option>Select Plan</option>

                          {mealplan.map((item) => (
                            <option key={item.MealPlanID} value={item.Code}>
                              {item.Name}
                            </option>
                          ))}
                        </select>

                      </div>
                    </div>
                    <div className='col-md-12'>
                      <div className='mb-3'>
                        <label className='form-label'>Add Room Amount</label>
                        <input className='form-control' type='number' min={0} value={roomAmount}
                          onChange={(e) => setRoomAmount(e.target.value)} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label"> ADULT </label>
                        <select className="form-control form-select" value={adults}
                          onChange={(e) => setAdults(e.target.value)}>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label"> CHILD </label>
                        <select className="form-control form-select" value={children}
                          onChange={(e) => setChildren(e.target.value)}>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label"> EXTRA BED </label>
                        <select className="form-control form-select" value={extraBed}
                          onChange={(e) => setExtraBed(e.target.value)}>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-info waves-effect waves-light" onClick={handleAddRoomSave} >
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* /.modal */}
        </>

      </div>
    </>

  );
};


export default HotelBooking;
